import React, { useRef } from 'react';
import { array } from 'prop-types';
import useOutsideOfElement from '../custom-hooks/useOutsideOfElement';

import MobileAllPlaces from './MobileAllPlaces';

function FilteredMobile({ filtered, setHideDropdown }) {
  const autocompleteRef = useRef(null);

  useOutsideOfElement({
    element: autocompleteRef,
    hook: setHideDropdown,
    value: true
  });

  if (filtered.length > 0) {
    return (
      <div ref={autocompleteRef} className="autocomplete-suggestions">
        <div className="autocomplete-block">
          <MobileAllPlaces
            className="autocomplete-suggestion suggestion"
            filtered={filtered}
          />
        </div>
      </div>
    );
  } else return null;
}

FilteredMobile.propTypes = {
  filtered: array.isRequired,
  //seeAllHotels: func.isRequired
};

export default FilteredMobile;
